import { stringify } from "uuid";

const url = "/orgaos";
const id = "idenOrgao";


export function buscarOrgaosNaoExtintos() {
    return new Promise((resolve, reject) => {
        window.$http.get(`${url}/naoextintos`).then((res) => {
            resolve(res.data);
        })
    })
}

